import { voiceMsgTypes } from "./voice.types";

const INITIAL_STATE = {
  voiceRecording: false,
  recordingAudio: null,
  audioStream: null,
};

const voiceMsgReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    //
    case voiceMsgTypes.SET_VOICE_RECORDING: {
      return {
        ...state,
        voiceRecording: action.payload,
      };
    }

    case voiceMsgTypes.SET_RECORDING_AUDIO: {
      return {
        ...state,
        recordingAudio: action.payload,
      };
    }

    case voiceMsgTypes.SET_AUDIO_STREAM: {
      return {
        ...state,
        audioStream: action.payload,
      };
    }

    case voiceMsgTypes.RESET_VOICE_RECORDING_DATA: {
      return {
        ...state,
        audioStream: null,
      };
    }

    default:
      return state;
  }
};

export default voiceMsgReducer;
